import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;

export default {
    getTriageTypeLists() {
        return Axios.get(`${baseURL}account/triage-type`)
            .then(response => response.data.response);
    },
    updateTriageType(triageId, params) {
        return Axios.put(`${baseURL}schedule/triage/update/${triageId}`, params)
            .then(response => response.data.response);
    },
    createNewTriage(params) {
        return Axios.post(`${baseURL}schedule/triage/save`, params)
            .then(response => response.data.response);
    }
};